<template>
  <div>
    <el-card>
      <div class="header-menu">
        <el-form :inline="true" label-width="100px">
          <el-form-item label="执行老师">
            <el-select
              class="select"
              filterable
              clearable
              v-model="from.ExecutiveTeacher"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in taskCreatorList"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="对应学生">
            <el-select
              class="select"
              filterable
              clearable
              v-model="from.CorrespondingStudents"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in studentList"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="任务名称">
            <el-select
              class="select"
              v-model="from.TaskName"
              placeholder="请选择任务名称："
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="source in TodoallList"
                :key="source.id"
                :value="source.id"
                :label="source.taskName"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="完成进度">
            <el-select
              class="select"
              filterable
              clearable
              v-model="from.CompletionProgress"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in classTypes_s"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="任务创建人">
            <el-select
              class="select"
              filterable
              clearable
              v-model="from.TaskCreator"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in taskCreatorList"
                :key="item.id"
                :value="item.id"
                :label="item.realname"
              >
              </el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="销售完成状态">
            <el-select
              class="select"
              filterable
              clearable
              v-model="from.marketSuccess"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="item in salesStateSelectList"
                :key="item.id"
                :value="item.id"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="截止日期:">
            <el-date-picker
              v-model="from.Deadline"
              clearable
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="任务创建日期:">
            <el-date-picker
              v-model="from.TaskCreationDate"
              clearable
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

          <el-row>
            <el-col :span="12" :push="12" style="text-align: right">
              <!-- <el-button
                type="primary"
                @click="handleDownload"
                class="btns"
                size="small"
                icon="el-icon-download"
                >导出任务</el-button
              > -->
              <el-button
                @click="handleClearList"
                class="btns"
                size="small"
                icon="el-icon-close"
                >清除</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="searchStudent"
                size="small"
                class="btns"
                >搜索</el-button
              >
              <el-button
                type="primary"
                @click="addStudent"
                class="btns"
                size="small"
                icon="el-icon-plus"
                >添加任务</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>

      <el-table
        :data="studentData"
        :stripe="true"
        :highlight-current-row="true"
        height="500"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column
          prop="executiveTeacherName"
          label="执行老师"
        ></el-table-column>
        <el-table-column prop="studentName" label="对应学生"></el-table-column>
        <el-table-column prop="taskName" label="任务名称"></el-table-column>
        <el-table-column prop="taskDetail" label="任务详情" width="300"></el-table-column>
        <el-table-column prop="impDatas" label="任务资料" width="200">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <span
              v-for="itme in JSON.parse(scope.row.impDatas)"
              :key="itme.uid"
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: block;
                color: #409eff;
              "
              @click="handleDownload_s(itme)">{{ itme.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="expirationDate"
          label="截止日期"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="expirationStartDate"
          label="截止开始时间"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="expirationEndDate"
          label="截止结束时间"
          width="150"
        ></el-table-column>
        <!-- <el-table-column
          prop="handlingResult"
          label="办理结果"
        ></el-table-column> -->
        <el-table-column prop="impDatas" label="上传资料" width="200">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <span
              v-for="itme in JSON.parse(scope.row.imps)"
              :key="itme.uid"
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: block;
                color: #409eff;
              "
              @click="handleDownload_s(itme)">{{ itme.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="successPlan" label="完成进度">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <span v-if="scope.row.successPlan == 0">待完成</span>
            <span v-if="scope.row.successPlan == 1">进行中</span>
            <span v-if="scope.row.successPlan == 2">已完成</span>
          </template>
        </el-table-column>
        <el-table-column prop="marketSuccess" label="销售完成状态" width="200">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
          <el-radio-group v-model="scope.row.marketSuccess" :disabled="scope.row.successPlan !== 2" @change="changeMarke(scope.row)">
            <el-radio :label="1">未完成</el-radio>
            <el-radio :label="2">已完成</el-radio>
          </el-radio-group>
        </template>
        </el-table-column>
        <el-table-column prop="createTime" label="任务创建日期" width="200">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <span>{{ scope.row.createTime.substring(0, 10) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="taskUserName" label="任务创建人" width="100">
        </el-table-column>
        <el-table-column label="操作" width="150">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <el-button type="text" @click="details(scope.$index, scope.row)" v-if="!showType"
              >详情
            </el-button>
            <el-button type="text" @click="editById(scope.$index, scope.row)"
              >编辑
            </el-button>
            <el-button type="text" @click="deleteById(scope.$index, scope.row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="display: flex; justify-content: center; margin-top: 10px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <el-dialog title="待办任务详情"  :visible.sync="showDetails" width="50%"  :before-close="handlesshowDetailsCler">

      <el-form>
        <el-form-item label="办理结果"  label-width="100px">
            <el-input :autosize="{ minRows: 6, maxRows: 6 }" v-model="showDetailsObj.handlingResult" disabled type="textarea" ></el-input>
        </el-form-item>
        <el-form-item label="上传资料" label-width="100px">
          <span style="display: block;" v-for="(itme, index) in showDetailsObj.imps" :key="index">{{itme.name}}</span>
        </el-form-item>
      </el-form>


    </el-dialog>

    <el-dialog append-to-body title="添加待办任务" :visible.sync="dialogToDoTasks1" :width="'80%'">
      <addDelegatedTasks :typeTil="typeTil" :itmesID="itmesID" :rows="rows" :showType="showType" @handleEventClr="handleEventClr" v-if="dialogToDoTasks1"></addDelegatedTasks>
    </el-dialog>


  </div>
</template>

<script>
import {
  ApiTeacherAll,
  ApiGetStudentList,
  ApiGetTodoList,
  ApiTodoDelete,
  ApiAddTodoall,
  markeStatus,
} from "../../api/apiTask";
import addDelegatedTasks from './addDelegatedTasks'

export default {
  name: "agencyTasks",
  components: {
    addDelegatedTasks,
  },
  props:['showType','itmesID'],
  data() {
    return {
      rows:{},
      typeTil:'',
      dialogToDoTasks1:false,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      studentData: [],
      taskCreatorList: [],
      studentList: [],
      TodoallList: [],
      classTypes_s: [
        { value: 0, label: "待完成" },
        { value: 1, label: "进行中" },
        { value: 2, label: "已完成" },
      ],
      salesStateSelectList: [
        { id: 1, label: "未完成" },
        { id: 2, label: "已完成" },
      ],
      from: {
        ExecutiveTeacher: "",
        CorrespondingStudents: "",
        TaskName: "",
        CompletionProgress: "",
        TaskCreator: "",
        marketSuccess:"",
        Deadline: [],
        TaskCreationDate: [],
      },
      page: 1,
      pageSize: 10,
      total: 0,
      showDetails:false,
      showDetailsObj:{
        handlingResult:"",
        imps:[],
      },
    };
  },

  created() {},
  mounted() {
    this.getApiTeacherAll();
    this.getApiGetTodoList();

  },
  methods: {
    handleEventClr(){
      this.getApiTeacherAll();
      this.getApiGetTodoList();
      this.dialogToDoTasks1 = false
    },

    changeMarke(row) {
      this.$confirm("此操作将修改销售完成状态, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            markeStatus(row).then(res => {
              if (res.code == 200) {
                this.$message.success(res.message)
              } else {
                this.$message.error(res.message)
              }
              this.getApiGetTodoList();
            })
          })
          .catch(() => {
            row.marketSuccess = "";
            this.$message({
              type: "warning",
              message: "已取消",
            });
            this.getApiGetTodoList();
          });
    },
    handleDownload_s(e) {
      let str = e.url.substring(0,5)
      console.log(str, '1111111111111111111111')
      if(str == 'https'){
        fetch(e.url)
        .then((response) => response.blob())
        .then((result) => {
            const objectUrl = window.URL.createObjectURL(result)
            const link = document.createElement('a')
            link.href = objectUrl
            link.download = e.name
            link.click()
            link.remove()
            window.URL.revokeObjectURL(objectUrl)
        })
      }else{
        let url = e.url.replace('http','https')
        fetch(url)
          .then((response) => response.blob())
          .then((result) => {
              const objectUrl = window.URL.createObjectURL(result)
              const link = document.createElement('a')
              link.href = objectUrl
              link.download = e.name
              link.click()
              link.remove()
              window.URL.revokeObjectURL(objectUrl)
          })
      }
    },
    addStudent() {
      if(this.showType){
          this.dialogToDoTasks1 = true
      }else{
          this.$router.push("/addDelegatedTasks");
      }
    },
    handleDownload() {
      let {
        ExecutiveTeacher,
        CorrespondingStudents,
        TaskName,
        CompletionProgress,
        TaskCreator,
        Deadline,
        TaskCreationDate,
      } = from;
      const params = {};
      axios
        .post(`${apiBaseUrl}/student/export`, params, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          });
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "学生.xlsx";
          downloadLink.click();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleClearList() {
      this.from = {
        ExecutiveTeacher: "",
        CorrespondingStudents: "",
        TaskName: "",
        CompletionProgress: "",
        TaskCreator: "",
        marketSuccess:"",
        Deadline: [],
        TaskCreationDate: [],
      };
      this.page = 1;
      this.getApiGetTodoList();
    },

    searchStudent() {
      this.page = 1;
      this.getApiGetTodoList();
    },
    deleteById(index, row) {
      this.$confirm("此操作将删除该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteStudentById(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    deleteStudentById(id) {
      ApiTodoDelete(id)
        .then((res) => {
          this.$message({ message: "删除成功", type: "success" });
          this.getApiGetTodoList();
        })
        .catch((error) => {
          this.$message.error("删除失败");
        });
    },

    editById(index, row) {
      if(this.showType){
          this.dialogToDoTasks1 = true
          this.typeTil = '编辑'
          this.rows = row
      }else{
        this.$router.push({
          path: "/addDelegatedTasks",
          query: {
            row,
          },
        });
      }


    },
    details(index,row){
      this.showDetails = true
      this.showDetailsObj.handlingResult = row.handlingResult
      let imps = JSON.parse(row.imps)
      if(imps.length > 0){
        this.showDetailsObj.imps = imps
      }
    },
    handlesshowDetailsCler(){
      this.showDetailsObj.handlingResult = ""
      this.showDetailsObj.imps = []
      this.showDetails = false
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getApiGetTodoList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getApiGetTodoList();
    },

    getApiTeacherAll() {
      ApiTeacherAll().then((res) => {
        let { data } = res;
        this.taskCreatorList = data;
      });
      ApiGetStudentList().then((res) => {
        let { data } = res;
        this.studentList = data;
      });
      ApiAddTodoall().then((res) => {
        let { data } = res;
        this.TodoallList = data;
      });
    },

    getApiGetTodoList() {
      let data = {
        pageNo: this.page,
        pageSize: this.pageSize,
        startTime: this.from.TaskCreationDate[0],
        endTime: this.from.TaskCreationDate[1],
        taskName: this.from.TaskName,
        executiveTeacher: this.from.ExecutiveTeacher,
        successPlan: this.from.CompletionProgress,
        taskUser: this.from.TaskCreator,
        // expirationDate: this.from.Deadline,
        startExpirationDate: this.from.Deadline[0],
        endExpirationDate: this.from.Deadline[1],
        studentId: this.from.CorrespondingStudents,
        marketSuccess:this.from.marketSuccess,
        communicationId: this.itmesID ? this.itmesID : '',
        toDoType:this.itmesID ? 2 : 1,
      };
      ApiGetTodoList(data).then((res) => {
        let { data } = res;
        this.studentData = data.records.map((itme) => {
          if (itme.impData) {
            itme.impDatas = itme.impData;
          }else{
            itme.impDatas = JSON.stringify({});
          }
          return itme;
        });

        this.studentData = data.records.map((itme) => {
          if (itme.imp) {
            itme.imps = itme.imp;
          }else{
            itme.imps = JSON.stringify({});
          }
          return itme;
        });

        console.log(this.studentData, 'this.studentData')

        this.$message.success('查询成功~');

        this.total = data.total;
        this.pageSize = data.size;
        this.page = data.current;
      });
    },
  },
};
</script>

<style scoped>
.el-input-group {
  width: 40%;
}

.header-menu {
  margin-bottom: 5px;
  padding: 0;
  text-align: left;
  margin-bottom: 5px;
}

.footer-button {
  margin-top: 10px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #bb >>> .el-dialog {
    width: 70%;
  }

  .el-input-group {
    width: 60%;
  }

  .sex {
    margin-left: -15% !important;
  }
}
.btns {
  background-color: #428bca;
  border-color: #428bca;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/assembly/agencyTasks.vue